import { render } from "./ProfileSection.vue?vue&type=template&id=a6e1bf74"
import script from "./ProfileSection.vue?vue&type=script&lang=js"
export * from "./ProfileSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__